import React, { Component } from "react";

import { Metric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class LastWeeksSummary extends Component {
  render() {
    const { data } = this.props.data;

    return (
      <div className="row d-flex justify-content-between">
        {data.installs && (
          <div className="col-6 col-md-2 mb-4">
            <Heading size={6} className={"mb-1"}>
              Uninstalls
            </Heading>
            <Metric {...data.installs} size={"lg"} />
          </div>
        )}

        {data.uninstalls && (
          <div className="col-6 col-md-2 mb-4">
            <Heading size={6} className={"mb-1"}>
              Uninstall Rate
            </Heading>
            <Metric {...data.uninstalls} size={"lg"} />
          </div>
        )}

        {data.uninstalls_rate && (
          <div className="col-6 col-md-2 mb-4">
            <Heading size={6} className={"mb-1"}>
              Uninstalls Rate
            </Heading>
            <Metric
              {...data.uninstalls_rate}
              size={"lg"}
              format="%"
              type="percentage"
            />
          </div>
        )}

        {data.cvr && (
          <div className="col-6 col-md-2 mb-4">
            <Heading size={6} className={"mb-1"}>
              CVR %
            </Heading>
            <Metric {...data.cvr} size="lg" format="%" type="percentage" />
          </div>
        )}

        {data.total_active_subscriptions && (
          <div className="col-6 col-md-2 mb-4">
            <Heading size={6} className={"mb-1"}>
              Total Active Subscriptions
            </Heading>
            <Metric {...data.total_active_subscriptions} size="lg" />
          </div>
        )}

        {data.new_paid && (
          <div className="col-6 col-md-2 mb-4">
            <Heading size={6} className={"mb-1"}>
              New Paid
            </Heading>
            <Metric {...data.new_paid} size="lg" />
          </div>
        )}

        {data.pct_to_goal && (
          <div className="col-6 col-md-2 mb-4">
            <Heading size={6} className={"mb-1"}>
              % to Goal
            </Heading>
            <Metric
              {...data.pct_to_goal}
              size="lg"
              format="%"
              type="percentage"
            />
          </div>
        )}

        {data.renewal_rate && (
          <div className="col-6 col-md-2">
            <Heading size={6} className={"mb-1"}>
              Renewal Rate
            </Heading>
            <Metric
              {...data.renewal_rate}
              size="lg"
              format="%"
              type="percentage"
            />
          </div>
        )}

        {data.churn_rate && (
          <div className="col-6 col-md-2">
            <Heading size={6} className={"mb-1"}>
              Churn Rate
            </Heading>
            <Metric
              {...data.churn_rate}
              size="lg"
              format="%"
              type="percentage"
            />
          </div>
        )}
      </div>
    );
  }
}

export default LastWeeksSummary;
